module.exports = __webpack_public_path__ + "img/upload-icon.c107b4cc.svg";